export default "__VITE_ASSET__n8LO_qD2__"